<template>
  <div>
    <div class="breadcrumbs">
      <div
        class="breadcrumb"
        v-for="breadcrumb in breadcrumbs"
        :key="typeof breadcrumb === 'object' ? breadcrumb.route : breadcrumb"
      >
        <!-- TODO: This makes it easier to just pass a string if we know the route string equals the label we want to display. But it makes things more brittle, so we may want to change it to always be an array of objects. -->
        <a
          @click="
            routeTo(
              typeof breadcrumb === 'object' ? breadcrumb.route : breadcrumb
            )
          "
        >
          {{ typeof breadcrumb === "object" ? breadcrumb.title : breadcrumb }}
        </a>
        <ag-icon color="#777777" width="12px" height="12px">
          <breadcrumb-icon />
        </ag-icon>
      </div>
    </div>
    <div class="title">
      {{ title }}
    </div>
  </div>
</template>

<script>
  import BreadcrumbIcon from "./icons/BreadcrumbIcon";

  export default {
    name: "Breadcrumbs",
    methods: {
      routeTo(route) {
        this.$router.push({ name: route });
      }
    },
    props: {
      breadcrumbs: {
        type: Array
      },
      title: {
        type: String,
        required: true
      }
    },
    components: {
      BreadcrumbIcon
    }
  };
</script>

<style lang="scss">
  .breadcrumbs {
    display: flex;

    .breadcrumb {
      display: flex;
      align-items: center;
      font-size: 12px;
      font-weight: $font-semibold;
    }

    a {
      color: $color-secondary;
      text-decoration: none;
      cursor: pointer;

      &:hover {
        color: $color-primary;
        text-decoration: underline;
      }
    }
  }

  .title {
    font-size: 18px;
    font-weight: $font-semibold;
    padding-top: 2px;
    padding-bottom: 25px;
  }
</style>
